// no imports
// import './module/map';
import '../styles/sass/main.scss';

import './vendor/element-closest';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import './module/carousel'; // loads flickity

import './module/menu';
import './module/modal';

import './module/form';
import './module/accordion';
import './module/tabs'; // This is loads flickity like the carousel module
import './module/externalLinks';

import './module/specialOffer';

// eslint-disable-next-line import/no-relative-packages
import './booking/src/portals-only';
// import './booking/src/index';
